import React from 'react';
import ReactDOM from 'react-dom/client';
import "./assets/scss/main.scss";
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
const root = ReactDOM.createRoot(document.getElementById('root'));
const Root = () => <BrowserRouter><App /></BrowserRouter>; // prettier-ignore
root.render(<Root />);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
